import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { BreakApi } from "../Models/Api/Breaks";
import type { Break } from "../Models/Domain/Breaks";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import camelize from "@/Utils/Camelize";

const BreakTransformer: TransformerExtended<Break, BreakApi> = {
  ...DefaultTransformerGenerator<Break, BreakApi>(),

  toDomain(input: BreakApi): Break {
    return camelize<BreakApi>(input) as Break;
  },
};

export type BreakTransformerType = TransformerExtended<Break, BreakApi>;

export default BreakTransformer;
